import { useOutletContext } from 'react-router'
import { Outlet } from 'react-router'

import { useScreenContext } from '../../context/GlobalContext'
import { CurrentUser } from '../../services/schema/User'
import SubBanner from '../../components/submain/SubBanner'
import SubBannerSimple from '../../components/submain/SubBannerSimple'

export const SubMainScroll: React.FC = () => {
  const { innerWidth } = useScreenContext()

  return (
    <>
      <Outlet context={useOutletContext<CurrentUser>()} />
      {innerWidth >= 1030 && <SubBanner />}
    </>
  )
}

export const SubMainNoScroll: React.FC = () => {
  const { innerWidth } = useScreenContext()
  return (
    <>
      <Outlet />
      {innerWidth >= 1030 && <SubBannerSimple />}
    </>
  )
}
